import Vue from 'vue';
import VueSvgIcon from 'vue-svgicon';
import {ICONS_SERVICE_INSTANCE} from '@/utils/icons.service';
import {MarkerService} from '@/utils/gmaps/gmaps.marker.service';

class IconMarker implements MarkerService<DisguiseDto.IconGmapsMarkerContent> {

    generateMarkerContent(config: DisguiseDto.IconGmapsMarkerContent): Node | null {
        let result: Node | null = null;
        if (config.icon) {
            const SVGIconComponent = Vue.extend(VueSvgIcon);
            const instance = new SVGIconComponent({
                propsData: {
                    icon: ICONS_SERVICE_INSTANCE.getIcon(config.icon),
                    width: (config.widthInPx || 24) + 'px',
                    height: (config.heightInPx || 24) + 'px',
                }
            });
            instance.$mount();
            result = instance.$el;
            instance.$destroy();
        }
        return result;
    }

    onClick(
      markerConfig: DisguiseDto.GMapsMarker,
      marker: google.maps.marker.AdvancedMarkerElement,
      allMarkers: google.maps.marker.AdvancedMarkerElement[],
      gmapsView: google.maps.Map
    ) {
        return;
    }

    onUserRequestedDetails(
      markerConfig: DisguiseDto.GMapsMarker,
      marker: google.maps.marker.AdvancedMarkerElement,
      allMarkers: google.maps.marker.AdvancedMarkerElement[],
      gmapsView: google.maps.Map
    ) {
        return;
    }

}

export {IconMarker};
